export const TermsAndConditions = () => {
  return (
    <div className="fixed inset-0 z-50 bg-neutral-100 overflow-y-auto">
      <div className="min-h-screen flex justify-center px-4 py-16">
        <div className="w-full max-w-5xl bg-white rounded-lg border border-neutral-200 px-8 sm:px-12 py-12">

          <h1 className="text-4xl font-semibold text-neutral-900 text-center mb-12">
            Terms and Conditions
          </h1>

          <div className="prose prose-neutral max-w-none text-neutral-800">

            <p className="text-base leading-relaxed">
              These Terms and Conditions ("Terms") govern your access to and use of the
              <strong> Busiconn </strong>
              platform, including social commerce, user-generated content, chats, and
              protected transactions. By creating an account or using Busiconn, you agree to
              comply with and be bound by these Terms.
            </p>

            {/* User Responsibilities */}
            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                User Responsibilities
              </h2>

              <div className="border border-neutral-200 rounded-md p-6">
                <ul className="list-disc pl-6 space-y-2">
                  <li>You must provide accurate profile/business information and maintain account confidentiality.</li>
                  <li>You are legally responsible for all activities conducted through your account.</li>
                  <li>Fraudulent, deceptive, or illegal activities are grounds for immediate termination.</li>
                  <li>Users must be at least 18 years old and legally eligible to enter into binding contracts in India.</li>
                </ul>
              </div>
            </section>

            {/* Buyers Rules */}
            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                Rules for Payers, Providers and General Users
              </h2>

              <div className="border border-neutral-200 rounded-md p-6">
                <ul className="list-disc pl-6 space-y-2">
                  <li>Do not share phone numbers, WhatsApp, email, or personal contact details.</li>
                  <li>Always complete payments through the Busiconn platform.</li>
                  <li>Do not request off-platform transactions.</li>
                  <li>Repeated violations may result in suspension or permanent ban.</li>
                  <li>Maintain respectful conduct in posts and chats.</li>
                </ul>
              </div>
            </section>

            {/* User-generated content */}
            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                User-Generated Content & Safety
              </h2>

              <div className="border border-neutral-200 rounded-md p-6">
                <ul className="list-disc pl-6 space-y-2">
                  <li>Posts, comments, profiles, messages, images, and videos must be lawful, accurate, and respectful.</li>
                  <li>Sexual or exploitative material, hate speech, threats, harassment, bullying, fraud, spam, impersonation, illegal goods, privacy violations, and intellectual-property infringement are prohibited.</li>
                  <li>Use the in-app controls to report objectionable content or users and to block abusive users.</li>
                  <li>Busiconn may review reports, reject or remove content, restrict messaging, and suspend or terminate accounts that violate these Terms.</li>
                  <li>Users must cooperate with moderation and must not misuse reporting or blocking tools.</li>
                </ul>
              </div>
            </section>

            {/* Payments */}
            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                Payments, Escrow & Refunds
              </h2>

              <div className="space-y-4 border border-neutral-200 rounded-md p-6">
                <p><strong>Protected payments:</strong> Payments are held until delivery confirmation or completion under the applicable deal flow.</p>
                <p><strong>Fees:</strong> Applicable payer and provider fees are shown before payment or a payment request is confirmed.</p>
                <p><strong>Refunds:</strong> Eligibility depends on the deal status, cancellation or dispute outcome, and payment release status.</p>
                <p><strong>Disputes:</strong> Must be raised within platform timelines.</p>
                <p><strong>Chargebacks:</strong> Unauthorized chargebacks may lead to suspension.</p>
                <p><strong>Mobile scope:</strong> Protected payments for digital products are not offered in the mobile apps.</p>
              </div>
            </section>

            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                Account Deletion & Privacy
              </h2>
              <div className="border border-neutral-200 rounded-md p-6">
                <p>
                  Users can initiate account deletion in the mobile app from Profile → Edit Profile → Delete Account,
                  or follow the instructions on our{" "}
                  <a className="text-primary-600 underline" href="/data-deletion">Data Deletion page</a>.
                  Personal data is deleted or de-identified except where financial, tax, fraud-prevention, dispute,
                  or other records must be retained by law. See our{" "}
                  <a className="text-primary-600 underline" href="/privacy-policy">Privacy Policy</a>.
                </p>
              </div>
            </section>

            {/* Liability */}
            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                Limitation of Liability
              </h2>

              <div className="border border-neutral-200 rounded-md p-6">
                <ul className="list-disc pl-6 space-y-2">
                  <li>Busiconn is not responsible for content quality or outcomes.</li>
                  <li>Not liable for shipping delays or third-party failures.</li>
                  <li>Maximum liability is limited to disputed transaction value.</li>
                  <li>
                    Off-platform transactions are entirely at user’s own risk,
                    with no protection or recourse.
                  </li>
                </ul>
              </div>
            </section>

            {/* Governing Law */}
            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                Governing Law
              </h2>
              <p>
                These Terms are governed by Indian law. Arbitration shall take
                place in New Delhi, India.
              </p>
            </section>

            {/* Contact */}
            <section className="mt-12">
              <h2 className="text-xl font-semibold text-neutral-900 mb-4">
                Contact
              </h2>

              <div className="border border-neutral-200 rounded-md p-6 text-sm">
                <p>Email: <strong>contact@busiconn.com</strong></p>
              </div>
            </section>

            <p className="text-xs text-neutral-500 text-center mt-16">
              Last Updated: 19 September 2026
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};
